module.exports = __webpack_public_path__ + "img/foot_img.71beeed3.png";